import api from '@/api';
import { API_BASE_URL } from '..';
import {
  EnterprisePecaAiBuyer,
  EnterprisePecaAiSearchProductRequest,
  EnterprisePecaAiSearchProductResponse,
  EnterprisePecaAiToken,
} from './pecaAi.types';
import { getPecaAiAccessToken, setPecaAiAccessToken } from './pecaAi.hooks';
import jwtDecode from 'jwt-decode';

const CONTROLLER = `${API_BASE_URL}/peca-ai`;

export default {
  async getToken() {
    const token = getPecaAiAccessToken();

    if (token) {
      const currentTimestamp = Math.floor(Date.now() / 1000);
      const decoded = jwtDecode<{ exp: number }>(token.access_token);

      const isValid = decoded.exp > currentTimestamp;

      if (isValid) return token;
    }

    const response = (await api.get(
      `${CONTROLLER}/token`,
      null,
    )) as unknown as EnterprisePecaAiToken;

    setPecaAiAccessToken(response);

    return response;
  },

  async getBuyer(companyId?: number) {
    const response = (await api.get(
      `${CONTROLLER}/${companyId}`,
      null,
    )) as unknown;
    return response as EnterprisePecaAiBuyer;
  },

  async searchProduct(params?: EnterprisePecaAiSearchProductRequest) {
    const response = (await api.get(
      `${CONTROLLER}/search-product`,
      params,
    )) as unknown;
    return response as EnterprisePecaAiSearchProductResponse;
  },
};
